import Flickity from "flickity"

const minimumSlidesInit = 4

const carousels = document.querySelectorAll("[data-carousel]")

;[...carousels].forEach(carousel => {
	// const slidesCount = $(this).find('.slider__item').length;

	// Not enough slides - disable arrows and exit early
	// if (slidesCount < minimumSlidesInit) {
	// 	arrows.each(function() {
	// 		$(this)
	// 			.attr('disabled', true)
	// 			.addClass('arrows__button--is-faded');
	// 	});
	// 	return;
	// }

	// Init flickity
	const flkty = new Flickity(carousel, {
		prevNextButtons: false,
		pageDots: false,
		cellSelector: ".listing__item",
		wrapAround: true,
		cellAlign: "left",
		contain: false,
		freeScroll: false,
		groupCells: "70%",
	})

	window.flkty = flkty

	const dotsContainer = carousel
		.closest(".listing__wrapper")
		.querySelector(".slider__dots")


	if (!!dotsContainer) {
		const renderDots = () => {
			dotsContainer.innerHTML = flkty.slides
				.map(
					(el, index) =>
						`<li class="slider__dot" aria-label="Page dot ${index +
							1}"></li>`
				)
				.join("")

			const dots = dotsContainer.querySelectorAll("li")
			const currentDot = dots[flkty.selectedIndex]
			currentDot.classList.add("is-selected")
			currentDot.setAttribute("aria-current", "step")

			const paginateContainer = carousel
			.closest(".listing__wrapper")
			.querySelector(".listing__pagination")

			const sliderCount = carousel
				.closest(".listing__wrapper")
				.querySelectorAll(".listing__item")

			if (sliderCount.length <= 3) {
				paginateContainer.style.display = 'none';
			}

			if (window.innerWidth < 1300 && sliderCount.length <= 3 ) {
				paginateContainer.style.display = 'flex';
			}

			// Add dot click handler
			;[...dotsContainer.querySelectorAll("li")].map(li =>
				li.addEventListener("click", e => {
					e.preventDefault()

					flkty.select(
						[...li.parentNode.querySelectorAll("li")].indexOf(li)
					)
				})
			)
		}

		renderDots()

		flkty.on("select", () => renderDots())
		flkty.on("resize", () => renderDots())

		const buttonPrev = dotsContainer.previousElementSibling
		const buttonNext = dotsContainer.nextElementSibling

		if (!!buttonPrev) {
			buttonPrev.addEventListener("click", e => {
				e.preventDefault()
				flkty.previous()
			})
		}

		if (!!buttonNext) {
			buttonNext.addEventListener("click", e => {
				e.preventDefault()
				flkty.next()
			})
		}
	}

	// // Enable the back arrow once user has interacted with flickity
	// flickity.on('change.flickity', function(event, index) {
	// 	arrows.each(function() {
	// 		$(this).attr('disabled', false);
	// 	});
	// });
})
